package uk.co.nickthecoder.kyd

import uk.co.nickthecoder.glok.scene.Color
import uk.co.nickthecoder.kyd.appearance.Appearance
import uk.co.nickthecoder.kyd.appearance.AppearanceResource
import uk.co.nickthecoder.kyd.shapes.*
import uk.co.nickthecoder.kyd.util.Vector2

class ShapeResource(

    parent: ParentResource,
    name: String

) : AbstractParentResource(parent, name), AppearanceResource, ResolvableResource {

    var fill: Paint = FlatPaint(Color.WHITE)
    var stroke: Paint = FlatPaint(Color.BLACK)
    var strokeWidth = 0f
    var strokeRatio = 0.5f
    var lineWidth = 1f
    var capStyle = CapStyle.ROUND
    var joinStyle = JoinStyle.ROUND

    override val resourceType: ResourceType
        get() = ResourceType.SHAPE

    override fun appearance(): Appearance {

        val shape: Shape = Polygon(
            listOf(
                Vector2(0f, 20f), Vector2(20f, - 20f), Vector2(- 20f, - 20f)
            )
        )

        return ShapeAppearance(shape).also {
            it.fill = fill.copy(this)
            it.stroke = stroke.copy(this)

            it.strokeWidth = strokeWidth
            it.strokeRatio = strokeRatio
            it.lineWidth = lineWidth
            it.capStyle = capStyle
            it.joinStyle = joinStyle
        }
    }

    override fun appearanceForActor(actor: Actor) = appearance()

    override fun resolveReferences(): String? {
        var result: String? = null
        val fill = fill
        if (fill is Resolvable) {
            result = fill.resolveReferences(this)
        }
        val stroke = stroke
        if (stroke is Resolvable) {
            result = result ?: stroke.resolveReferences(this)?.let { return it }
        }
        return result
    }
}
